import {
  Component,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TreeMode } from 'tree-ngx';
import { HttpClient } from '@angular/common/http';
import { Map } from '../admin/map-editor/map';

@Component({
  selector: 'maps',
  styleUrls: ['./maps.component.scss'],
  templateUrl: './maps.component.html'
})

export class MapsComponent implements OnInit {

  public mapValidator: Map[];
  public localState: any;
  public selectedValue: MapCatalogItem;
  public nodeItems: TreeItem[] = [];
  public mockData: MapCatalogItem[];
  public options = {
    mode: TreeMode.SingleSelect,
    checkboxes: false,
    alwaysEmitSelected: true
  };

  constructor(
    public route: ActivatedRoute,
    private http: HttpClient
  ) {
  }

  public download(sourceText, fileIdentity) {
    let workElement = document.createElement('a');
    if ('download' in workElement) {
      workElement.href = 'data:' + 'text/plain' + 'charset=utf-8,' + sourceText;
      workElement.setAttribute('download', fileIdentity + '.znc');
      document.body.appendChild(workElement);
      let eventMouse = document.createEvent('MouseEvents');
      eventMouse.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      workElement.dispatchEvent(eventMouse);
      document.body.removeChild(workElement);
    } else throw 'File saving not supported for this browser';
  }

  public setNodeItem(items: Map[]) {
    if (items.length) {
      this.selectedValue = items[0];
    }
  }

  public ngOnInit() {
    this.http.get(remoteApiHost + 'getMaps').subscribe((data: MapCatalogItem[]) => {
      this.processData(data);
    });
  }

  private processData(data: MapCatalogItem[]) {
    this.mockData = [];
    for (let i of data) {
      let map = new Map(this.http);
      map.Updated = i.Updated;
      map.Created = i.Created;
      map.Bbox = i.Bbox;
      map.Screenshot = i.Screenshot;
      map.Path = i.Path;
      map.Name = i.Name;
      map.Config = i.Config;
      map.Description = i.Description;
      this.mockData.push(map);
    }
    for (let i = 0; i < this.mockData.length; i++) {
      const dataItem = this.mockData[i];
      let x = dataItem.Path.split('/');
      let parentFolder: TreeItem;
      let currentFolder: TreeItem;
      for (let ii = 0; ii < x.length; ii++) {
        currentFolder =
          this.getTreeItemByName(x[ii], ii === 0 ? this.nodeItems : parentFolder.children, 0);
        if (!currentFolder) {
          currentFolder = {
            id: i.toString() + ii.toString(),
            name: x[ii]
          };
          if (!parentFolder) {
            this.nodeItems.push(currentFolder);
          } else {
            if (!parentFolder.children) { parentFolder.children = []; }
            parentFolder.children.push(currentFolder);
          }
        }
        parentFolder = currentFolder;
      }
      if (!parentFolder.children) { parentFolder.children = []; }
      parentFolder.children.push({
        item: dataItem,
        id: dataItem.Path + '/' + dataItem.Name,
        name: dataItem.Name
      });
    }
  }

  private getTreeItemByName(name: string, items: TreeItem[], level: number): TreeItem {
    if (!items) { return; }
    for (let child of items) {
      if (level > 0) {
        let result = this.getTreeItemByName(name, child.children, level - 1);
        if (result) { return result; }
      } else if (child.name === name) { return child; }
    }
  }
}

export interface TreeItem {
  id: string;
  name: string;
  children?: TreeItem[];
  item?: MapCatalogItem;
}

export interface MapCatalogItem {
  Created: Date;
  Updated: Date;
  Bbox: [number, number, number, number];
  Screenshot: string;
  Path: string;
  Name: string;
  Config: string;
  Description: string;
}



// WEBPACK FOOTER //
// ./src/app/maps/maps.component.ts